class Scrollspy {
  constructor() {
    const navbarHome = document.getElementById('startpage-navbar-group');

    if (navbarHome != null) {
      const sections = document.querySelectorAll('.content > .ns-header-img, .content > .lc-keyfigure-container, .content > .ns-slider-wrapper, .content > .lc-grid');
      const navbarItems = document.getElementById('startpage-navbar-group--list');
      const nsHeaderImgInner = document.querySelector('.ns-header-img__inner');
      const offset = 0;

      sections.forEach((section, index) => {
        const title = section.querySelector('.lc-scrollspy-title');
        const sectionNumber = index + 1;
        const sectionId = `section-${sectionNumber}`;
        section.id = sectionId;

        const navItem = document.createElement('li');
        navItem.classList.add('startpage-navbar-group__item');
        navItem.innerHTML = `<a class="startpage-navbar-group__link" data-number="${sectionNumber}" href="#${sectionId}"><span class="startpage-navbar-group__link-title">${title.innerText}</span><span class="startpage-navbar-group__bullet"></span></a>`;
        navbarItems.appendChild(navItem);
      });

      const navBar = document.querySelector('.startpage-navbar-group');
      const links = navBar.querySelectorAll('.startpage-navbar-group__link');

      links.forEach(link => {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          const targetId = link.getAttribute('href').substring(1);
          const targetSection = document.getElementById(targetId);
          window.scrollTo({
            top: targetSection.offsetTop - offset,
            behavior: 'smooth'
          });
        });
      });

      const body = document.body;
      const html = document.documentElement;

      const indicator = document.querySelector('.startpage-navbar-group__progress-indicator');

      window.addEventListener('scroll', () => {
        let currentSection = null;
        sections.forEach((section, index) => {
          const sectionTop = section.offsetTop - offset;
          if (window.scrollY >= sectionTop - 200) {
            currentSection = index + 1;
          }
        });

        if (currentSection) {
          const navbarInner = navBar.querySelector('.startpage-navbar-group__inner');
          const bullets = navBar.querySelectorAll('.startpage-navbar-group__bullet');
          const activeBullet = bullets[currentSection - 1];

          if (activeBullet && navbarInner) {
            const navbarInnerRect = navbarInner.getBoundingClientRect();
            const currentBulletRect = activeBullet.getBoundingClientRect();
            const currentBulletPosition = currentBulletRect.top - navbarInnerRect.top + (currentBulletRect.height / 2);

            const currentSectionElement = sections[currentSection - 1];
            const nextSectionElement = sections[currentSection];

            if (nextSectionElement && currentSection < sections.length) {
              const nextBullet = bullets[currentSection];
              const nextBulletRect = nextBullet.getBoundingClientRect();
              const nextBulletPosition = nextBulletRect.top - navbarInnerRect.top + (nextBulletRect.height / 2);

              const sectionStart = currentSectionElement.offsetTop - offset;
              const sectionEnd = nextSectionElement.offsetTop - offset;
              const scrollProgress = (window.scrollY - sectionStart) / (sectionEnd - sectionStart);

              const interpolatedHeight = currentBulletPosition + (nextBulletPosition - currentBulletPosition) * scrollProgress;
              indicator.style.height = `${interpolatedHeight + 30}px`;
            } else {
              const lastSectionStart = currentSectionElement.offsetTop - offset;
              const totalScroll = document.documentElement.scrollHeight - window.innerHeight;
              const currentScroll = window.scrollY;
              const progressAfterLastSection = (currentScroll - lastSectionStart) / (totalScroll - lastSectionStart);

              const extraGrowth = progressAfterLastSection * 44;
              indicator.style.height = `${currentBulletPosition + 30 + extraGrowth}px`;
            }
          }
        } else {
          indicator.style.height = '0px';
        }

        const nsHeaderImgInnerBottom = nsHeaderImgInner
          ? nsHeaderImgInner.getBoundingClientRect().bottom
          : 0;

      const footer = document.querySelector('footer');
      const footerTop = footer.offsetTop;
      const navBarGroup = document.querySelector('.startpage-navbar-group');
      const navBarGroupHeight = navBarGroup.offsetHeight;
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;


      if (scrollPosition + window.innerHeight/2 + navBarGroupHeight/2 + 25 >= footerTop) {
          navBar.style.position = 'absolute';
          navBar.style.transform = 'none';
          navBar.style.bottom = '25px';
        } else {
          navBar.style.position = 'fixed';
          navBar.style.bottom = '50%';
          navBar.style.transform = 'translateY(50%)';
        }

        if (window.scrollY >= nsHeaderImgInnerBottom) {
          navBar.classList.add('visible');
        } else {
          navBar.classList.remove('visible');
        }

        links.forEach((link, index) => {
          if (index + 1 === currentSection) {
            link.parentNode.classList.add('active');
            link.parentNode.classList.remove('scrolled-past');
          } else if (index < currentSection) {
            link.parentNode.classList.add('scrolled-past');
          } else {
            link.parentNode.classList.remove('active', 'scrolled-past');
          }
        });
      });
    }
  }
}

export default Scrollspy;
